const Footer = () => {
    return (
        <footer className="footer card px-4">
            <div className="row gx-5 py-8 px-15">
                <div className="col text-start align-self-center text-muted">
                    <p className='m-0'>© 2025 LPDP. All rights reserved.</p>
                </div>
                <div className="col text-end">
                    <a href="https://www.instagram.com/lpdp_ri/" target="_blank" rel="noopener noreferrer" className="me-3">    
                        <img width={24} src={require('../../../assets/img/social-media/Instagram.png')} alt="Logo Instagram" />
                    </a>
                    <a href="https://x.com/LPDP_RI/" target="_blank" rel="noopener noreferrer" className="me-3">    
                        <img width={24} src={require('../../../assets/img/social-media/Twitter.png')} alt="Logo X" />
                    </a>
                    <a href="https://www.linkedin.com/company/lembaga-pengelola-dana-pendidikan//" target="_blank" rel="noopener noreferrer" className="me-3">    
                        <img width={24} src={require('../../../assets/img/social-media/LinkedIn.png')} alt="Logo Linkedin" />
                    </a>
                    <a href="https://www.facebook.com/LPDPKemenkeu" target="_blank" rel="noopener noreferrer" className="me-3">
                        <img width={24} src={require('../../../assets/img/social-media/Facebook.png')} alt="Logo Facebook" />
                    </a>
                    <a href="https://www.youtube.com/c/LPDPRI" target="_blank" rel="noopener noreferrer" className="me-3">
                        <img width={24} src={require('../../../assets/img/social-media/YouTube.png')} alt="Logo Youtube" />
                    </a>
                    <a href="https://www.tiktok.com/@lpdp_ri" target="_blank" rel="noopener noreferrer">
                        <img width={24} src={require('../../../assets/img/social-media/TikTok.png')} alt="Logo TikTok" />
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer